import React from 'react';
import { Line } from 'react-chartjs-2';

const AnalyticsSection = ({ analytics }) => (
  <div className="analytics-section">
    <h3>Applicants Over Time</h3>
    <div className="chart-container large">
      <Line
        data={{
          labels: analytics.map(a => new Date(a.date).toLocaleDateString()), // Format date for readability
          datasets: [{
            label: 'Applicants',
            data: analytics.map(a => a.applications), // <-- use 'applications'
            borderColor: '#3b82f6',
            backgroundColor: 'rgba(59,130,246,0.1)'
          }]
        }}
      />
    </div>
  </div>
);

export default AnalyticsSection;